"use strict";

var moment = require('moment-business-days');

var getOrderShippingOptions = require('./getOrderShippingOptions');
/**
 * Estimate the arrival time of a Shipment
 * @param {Shipment} shipment - the Shipment of interest
 * @param {*} services - from config
 */


function estimateArrivalDate(shipment, order, options) {
  var opts = getOrderShippingOptions(order, options); // sort them into title:transitTime pairs

  var collatedCategories = {};
  opts.forEach(function (_ref) {
    var title = _ref.title,
        transitTime = _ref.transitTime;
    collatedCategories[title] = transitTime;
  }); // get the corresponding transit time

  var service = shipment.service;
  var transitTime = collatedCategories[service]; // get the shipment's ship_by_date and add transitTime

  var ship_by_date = shipment.ship_by_date;
  return moment(ship_by_date).businessAdd(transitTime, 'days');
}

function estimateCustomerFacingArrivalDate(shipment, order, options) {
  var opts = getOrderShippingOptions(order, options); // sort them into title:transitTime pairs

  var collatedCategories = {};
  opts.forEach(function (_ref2) {
    var title = _ref2.title,
        transitTime = _ref2.transitTime;
    collatedCategories[title] = transitTime;
  }); // get the corresponding transit time

  var service = shipment.service;
  var transitTime = collatedCategories[service]; // get the shipment's ship_by_date and add transitTime

  var ship_by_date = shipment.customer_ship_by_date;
  return moment(ship_by_date).businessAdd(transitTime, 'days');
}

module.exports = {
  estimateArrivalDate: estimateArrivalDate,
  estimateCustomerFacingArrivalDate: estimateCustomerFacingArrivalDate
};